<template>
  <div
    class="counter flex text-sm md:text-base animate"
    :class="{ 'blocked': internalVal === 0 && blocked }"
  >
    <button
      class="minus w-8 md:w-12 h-full focus:outline-none flex justify-center items-center bg-primary rounded-l"
      @click="changeVal(-1)"
    >
      <MinusIcon />
    </button>
    <input
      type="text"
      :value="value"
      class="val w-12 md:w-18 text-center border border-gray-100 border-r-0 border-l-0"
      @input="$emit('change', $event.target.value)"
    >
    <button
      class="plus w-8 md:w-12 h-full focus:outline-none flex justify-center items-center bg-primary rounded-r"
      @click="changeVal(1)"
    >
      <PlusIcon />
    </button>
  </div>
</template>
<script>
import MinusIcon from '@/assets/icons/minus.svg';
import PlusIcon from '@/assets/icons/plus.svg';

export default {
  name: 'BaseCounter',
  components: {
    PlusIcon,
    MinusIcon,
  },
  props: {
    sum: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 0,
    },
    blocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalVal: 0,
    };
  },
  watch: {
    value(newVal) {
      this.internalVal = newVal;
    },
    internalVal(newVal, oldVal) {
      this.$emit('change', this.internalVal);
      this.$nextTick()
        .then(() => {
          if (this.internalVal < 0) {
            this.internalVal = 0;
            this.$emit('change', this.internalVal);
          } else if ((this.sum) > (this.max)) {
            this.internalVal = +oldVal;
            this.$emit('change', this.internalVal);
          }
        });
    },
  },
  methods: {
    changeVal(val) {
      if (!(this.blocked && this.internalVal === 0)) {
        this.internalVal += val;
      }
    },
  },
};
</script>
<style lang="scss">
  .blocked {
    opacity: 0.5;
    pointer-events: none;
  }
</style>
